import React from "react";
import { Link } from "react-router-dom";
class SideBarNav extends React.Component {
  render() {
    return (
        <div className="col-lg-4">
          <div className="mt-0 features_desc">
            {/* <p className="text-custom mb-0 features_small_title">MightyWiFi</p> */}
            <h4 className="features_title">My Account</h4>
            {/* <div>
            <img src="/images/divider.png" alt="" className="img-fluid" />
          </div> */}

            <div className="progress-bars skill-custom mt-4">
              <div className="clearfix">
                <div className="text-dark font-weight-bold float-left myaccount">
                  <Link to="/dashboard">Profile Settings</Link>
                </div>
              </div>

              <div className="clearfix">
                <div className="text-dark font-weight-bold float-left myaccount">
                  <Link to="/dashboard/orderhistory">Order History</Link>
                </div>
              </div>

              <div className="clearfix">
                <div className="text-dark font-weight-bold float-left myaccount">
                  <Link to="/dashboard/autorenewal">Auto Renewal</Link>
                </div>
              </div>

              <div className="clearfix">
                <div className="text-dark font-weight-bold float-left myaccount">
                  <Link to="/dashboard/update/password">Update Password</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
    );
  }
}

export default SideBarNav;



// WEBPACK FOOTER //
// ./src/pages/dashboard/SideBarNav.js